module.exports = __webpack_public_path__ + "static/media/Girls.e78e1540.png";